// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var PasswordChangeController = function ($rootScope, $scope, PasswordSettings, CheckPasswordStrength, Throttle, AccountLogout) {
    $scope.passwordSettings = new PasswordSettings();
    var estimationResult = Throttle(CheckPasswordStrength, 1000, function (response) { $scope.estimationResult = response.data; });

    $scope.preview = function () {
        var checkPasswordData = { password: $scope.passwordSettings.NewPassword, email: $scope.username }
        estimationResult.request(checkPasswordData);
    };

    $scope.changePassword = function () {
        $scope.passwordSettings.$update({}, function () {
            AccountLogout.logout();
        });

    };
};
PasswordChangeController.$inject = ['$rootScope', '$scope', 'PasswordSettings','CheckPasswordStrength', 'Throttle', 'AccountLogout'];
